<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 17:26:40
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 14:47:27
 * @Description: 生成月报价
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\dialog\monthPriceDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="monthPriceDialog" width="1300px" :append-to-body="true"
    :close-on-click-modal="false" :before-close="close" @open="openMethod">
    <span v-if="showType == 2" slot="title" class="dialog-title">生成月报价</span>
    <span v-else slot="title" class="dialog-title">生成结算价</span>
    <div style="margin: 15px 25px">
      <el-button key="update" size="mini" :disabled="isLook" class="bottom_one"
        @click="updatePriceDetail">更新数据</el-button>
    </div>
    <div v-if="monthPriceData.adjustPriceType == 3" style="margin: 15px 0px">泵送:</div>
    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
      style="width: 100%"
      :data="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? priceData.settlementPrices : priceData.specialPrices"
      tooltip-effect="dark">
      <el-table-column align="center" :label="showType == 1 ? '产品' : '标号'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'strengthGrade' : 'productName'"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期确认结算价' : '本期确认月报价'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'confirmPrice' : 'settlementConfirmPrice'">
        <template slot-scope="scope">
          <el-input
            v-if="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3"
            v-model="scope.row.confirmPrice" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
            :disabled="isLook" @input="scope.row.confirmPrice = $regExp.checkNum4(scope.row.confirmPrice)"
            @blur="scope.row.confirmPrice = $regExp.blurCheckNum(scope.row.confirmPrice)"></el-input>
          <el-input v-else v-model="scope.row.settlementConfirmPrice"
            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" :disabled="isLook"
            @input="scope.row.settlementConfirmPrice = $regExp.checkNum4(scope.row.settlementConfirmPrice)"
            @blur="scope.row.settlementConfirmPrice = $regExp.blurCheckNum(scope.row.settlementConfirmPrice)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期结算价' : '本期月报价'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'price' : 'settlementPrice'"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '上月确认结算价' : '上月确认月报价'"
        prop="lastConfirmPrice"></el-table-column>
    </el-table>
    <div v-if="monthPriceData.adjustPriceType == 3" style="margin: 15px 0px">非泵送:</div>
    <el-table v-if="monthPriceData.adjustPriceType == 3" :header-cell-style="{ background: '#f3f6f9' }"
      :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="priceData.settlementPriceTwos"
      tooltip-effect="dark">
      <el-table-column align="center" :label="showType == 1 ? '产品' : '标号'" prop="strengthGrade"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期确认结算价' : '本期确认月报价'" prop="confirmPrice">
        <template slot-scope="scope">
          <el-input v-model="scope.row.confirmPrice"
            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" :disabled="isLook"
            @input="scope.row.confirmPrice = $regExp.checkNum4(scope.row.confirmPrice)"
            @blur="scope.row.confirmPrice = $regExp.blurCheckNum(scope.row.confirmPrice)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期结算价' : '本期月报价'" prop="price"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '上月确认结算价' : '上月确认月报价'"
        prop="lastConfirmPrice"></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="infoSubmitFun">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { savePrising,queryPatternList } from "@/api/internetSales/engineeringControl.js";
import { queryPriceDetail2, updatePriceDetail, saveOrUpdate } from "@/api/internetSales/monthlyReportUnitRecord.js";
export default {
  components: {},
  props: {
    monthPriceDialog: {
      type: Boolean,
      default: false,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    //1混凝土 2月报
    showType: {
      type: Number,
      default: 1,
    },
    //1已确认 0待确认
    sureStatus: {
      type: Number,
      default: 0,
    },
    //1调价周期记录 2信息价期数
    monthPriceType: {
      type: Number,
      default: 1,
    },
    //为信息价期数时,最外层的类型
    adjustPriceType: {
      type: Number,
      default: 1,
    },
    monthPriceData: {
      type: Object,
      default: () => { },
    },
    // infoNumId: {
    //     type: String,
    //     default: '',
    // },
    // engineeringId: {
    //     type: String,
    //     default: '',
    // },
  },
  data() {
    return {
      priceData: [],
      priceData2: [],
      files: [],
      areaList: "",
      settlementPricesCopy: [],
      settlementPriceTwosCopy: [],
      specialPricesCopy: [],
      type3Flag: false,
    };
  },
  created() { },
  methods: {
    openMethod() {
      this.queryPriceDetail();
    },
    queryPriceDetail() {
      queryPriceDetail2({ dataId: this.monthPriceData.id, type: this.monthPriceType }).then(res => {
        if (res.code == 1001) {
          this.priceData = res.data;
          this.priceData.settlementPriceTwos = this.priceData.settlementPriceTwos || [];
          this.priceData.settlementPrices = this.priceData.settlementPrices || [];
          this.priceData.specialPrices = this.priceData.specialPrices || [];
          this.settlementPricesCopy = JSON.parse(JSON.stringify(this.priceData.settlementPrices || []));
          this.settlementPriceTwosCopy = JSON.parse(JSON.stringify(this.priceData.settlementPriceTwos || []));
          this.specialPricesCopy = JSON.parse(JSON.stringify(this.priceData.specialPrices || []));
        }
      });
    },
    updatePriceDetail() {
      this.$confirm("是否确认更新?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updatePriceDetail({ dataId: this.monthPriceData.id, type: this.monthPriceType }).then(res => {
            if (res.code == 1001) {
              this.$message.success("更新成功!");
              this.priceData = res.data;
              this.priceData.settlementPriceTwos = this.priceData.settlementPriceTwos || [];
              this.priceData.settlementPrices = this.priceData.settlementPrices || [];
              this.priceData.specialPrices = this.priceData.specialPrices || [];
              this.settlementPricesCopy = JSON.parse(JSON.stringify(this.priceData.settlementPrices || []));
              this.settlementPriceTwosCopy = JSON.parse(JSON.stringify(this.priceData.settlementPriceTwos || []));
              this.specialPricesCopy = JSON.parse(JSON.stringify(this.priceData.specialPrices || []));
              this.type3Flag = true;
            }
          });
        })
        .catch(() => { });
    },
    infoSubmitFun() {
      //已确认才进行判断
      if (this.sureStatus == 1) {
        if (!this.type3Flag) {
          let type3 = false;
          if (this.monthPriceData.adjustPriceType == 4) {
            this.priceData.specialPrices.forEach((item, index) => {
              if (item.productName != this.specialPricesCopy[index]?.productName) {
                type3 = true;
              } else {
                if (item.settlementConfirmPrice != this.specialPricesCopy[index]?.settlementConfirmPrice) {
                  type3 = true;
                }
              }
            });
          } else {
            this.priceData.settlementPrices.forEach((item, index) => {
              if (item.strengthGrade != this.settlementPricesCopy[index]?.strengthGrade) {
                type3 = true;
              } else {
                if (item.confirmPrice != this.settlementPricesCopy[index]?.confirmPrice) {
                  type3 = true;
                }
              }
            });
            if (this.monthPriceData.adjustPriceType == 3) {
              this.priceData.settlementPriceTwos.forEach((item, index) => {
                if (item.strengthGrade != this.settlementPriceTwosCopy[index]?.strengthGrade) {
                  type3 = true;
                } else {
                  if (item.confirmPrice != this.settlementPriceTwosCopy[index]?.confirmPrice) {
                    type3 = true;
                  }
                }
              });
            }
          }
          if (!type3) {
            this.$message.warning("表格数据没有修改，不允许保存！");
            return;
          }
        }
      }
      let type = false;
      let type2 = false; // 判断确认价范围在200-2000
      if (this.monthPriceData.adjustPriceType == 1 || this.monthPriceData.adjustPriceType == 2 || this.monthPriceData.adjustPriceType == 3) {
        if (this.priceData.settlementPrices.length > 0) {
          this.priceData.settlementPrices.forEach(item => {
            if (!item.confirmPrice && item.confirmPrice !== 0) {
              type = true;
            }
            if (item.confirmPrice < 150 || item.confirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      } else {
        if (this.priceData.specialPrices.length > 0) {
          this.priceData.specialPrices.forEach(item => {
            if (!item.settlementConfirmPrice && item.settlementConfirmPrice !== 0) {
              type = true;
            }
            if (item.settlementConfirmPrice < 150 || item.settlementConfirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      }
      if (this.monthPriceData.adjustPriceType == 3) {
        if (this.priceData.settlementPriceTwos.length > 0) {
          this.priceData.settlementPriceTwos.forEach(item => {
            if (!item.confirmPrice && item.confirmPrice !== 0) {
              type = true;
            }
            if (item.confirmPrice < 150 || item.confirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      }
      if (type) {
        this.$message.warning("表格数据填写不完整！");
        return;
      }
      if (type2) {
        this.$message.warning("价格范围为200-2000！");
        return;
      }
      this.priceData.dataId = this.monthPriceData.id;
      this.priceData.dataSource = this.monthPriceType;
      this.priceData.adjustPriceType = this.monthPriceType == 1 ? this.monthPriceData.adjustPriceType : "";
      saveOrUpdate(this.priceData).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.type3Flag = false;
          this.close();
        }
      });
    },
    close() {
      this.$emit("closeMonthPriceDialog", false);
    },
    setMonthPrice(row) {
      console.log(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.popperClass.el-date-picker {
  width: 220px;
}
</style>